export default {
  startRegisterResponse: null
};
